// Dependecies
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// store
import user from '../../store/user';
// Hooks
import useLanguage from '../useLanguage';

function useLogin({ error = '' }) {
  const { locale } = useLanguage();
  const [t] = useTranslation('routers', 'alert', { useSuspense: false });
  const prevLocationWorkshop = `/${locale}/${t('MaintenanceSchedule')}`;
  const prevLocationCompany = `/${locale}/${t('CompanyDashboard')}`;
  const history = useHistory();
  const [userStore, userActions] = user();
  const [rolId, setUseRolId] = useState(userStore.rol);
  const [messageError, setMessageError] = useState(error);

  useEffect(() => {
    if (userStore.token) {
      setUseRolId(userStore.rol);
    }
  }, [userStore.rol]);

  const submit = (data) => {
    try {
      const userData = {
        email: data.email,
        password: data.password,
      };

      userActions.login(userData).then(
        (responserol) => {
          if (responserol === 4 || responserol === 8) {
            history.push(prevLocationWorkshop);
          } else if (responserol === 3 || responserol === 7 || responserol === 9) {
            history.push(prevLocationCompany);
          } else {
            setMessageError(`${t('alert:login-error')}`);
          }
        },
        (e) => {
          if (e.message === 'invalid_credentials') {
            setMessageError(`${t('alert:login-invalid')}`);
          } else {
            setMessageError(`${t('alert:error-send')}`);
          }
        }
      );
    } catch (errorLogin) {
      setMessageError(errorLogin.message);
    }
  };

  const logout = (event) => {
    event.preventDefault();
    userActions.logout().then(
      () => {
        history.push('/');
      },
      (e) => {
        setMessageError(e.message);
      }
    );
  };

  return {
    submit,
    messageError,
    rolId,
    logout,
  };
}

export default useLogin;
